/* eslint-disable */
import "../../asset/css/demo.css";
import { useState, useRef } from "react";
import { motion, useInView } from "framer-motion";
import DemoModal from "../modal/DemoModal";

export default function DemoSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: false });

  const [demoModal, setDemoModal] = useState(false);
  return (
    <div className="demo_section_container">
      <motion.span
        // ref={ref}
        // style={{
        //   transform: isInView ? "none" : "translateX(-200px)",
        //   opacity: isInView ? 1 : 0,
        //   transition: "all .1s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s",
        // }}

        initial={{ opacity: 0, scale: 0.5 }}
        whileInView={{ opacity: 1, scale: 1.2 }}
        transition={{
          duration: 0.8,
          delay: 0.5,
          ease: [0, 0.71, 0.2, 1.01],
        }}
      >
        We Build New Construction Way!
      </motion.span>

      {demoModal && <DemoModal demoModal={demoModal} setDemoModal={setDemoModal} />}
    </div>
  );
}
